/**
 * Created by lari on 07/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.zipcode')
    .component('zipcode', {
      restrict: 'E',
      bindings: {
        zip: '<',
        city: '<',
        parentsave: '&',
        ti: '@?',
        ti2: '@?'
      },
      template: `
        <div class="form-group zipcode-component" style="padding: 0px; margin-bottom: 0px" data-hook="zipcode-component">
          <span class="col-md-4" style="padding: 0px; margin-top: 0px"><label for="postcode">PLZ</label>
              <span class="input-group">
                  <input type="text" ng-model="vm.zip" ng-show="vm.zip" tabindex="{{vm.ti}}" data-hook="zipcode-zip"
                          class="form-control" id="postcode" placeholder="PLZ">
                  <input type="text" class="form-control" ng-hide="vm.zip" tabindex="{{vm.ti}}"
                         data-hook="zipcode-zipsearch"
                         autocomplete="noway"
                         id="postcode"
                         placeholder="PLZ"
                         ng-model="vm.asyncSelected"
                         ng-blur="vm.foreignzip()"
                         typeahead-on-select="vm.getzipcity($item, $model, $label)"
                         uib-typeahead="zip as zip.text for zip in vm.getNames($viewValue)"
                         typeahead-loading="loadingNames"
                         typeahead-min-length="4"
                         typeahead-no-results="noResults">
                   <span class="input-group-btn">
                        <button class="btn btn-danger" tabindex="-1"
                                ng-click="vm.zip = ''; vm.city = ''; vm.asyncSelected = ''">
                            <i class="fa fa-remove"></i>
                        </button>
                   </span>
              </span>
          </span><!-- css sucks, do not remove this comment
       --><span class="col-md-8" style="padding: 0px">
          <label for="postcode">Ort</label>
              <input type="text" ng-model="vm.city" autocomplete="noway" tabindex="{{vm.ti2}}"
                     ng-blur="vm.save()"
                     data-hook="zipcode-city"
                     class="form-control" id="city" placeholder="Ort">
          </span>
      </div>
      <div ng-show="noResults">
          <i class="fa fa-warning"></i> Keine Orte gefunden
      </div>
      <span ng-show="loadingNames"><i class="fa fa-spin fa-spinner"></i> Daten werden geladen ... </span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Zipcode',
        function ($log, Zipcode) {
          let vm = this;
          vm.title = 'zipcode-component-controller';

          vm.getzipcity = getzipcity;
          vm.foreignzip = foreignzip;
          vm.getNames = getNames;
          vm.save = save;

          vm.$onInit = function () {
            vm.lastzip = angular.copy(vm.zip);
            vm.lastcity = angular.copy(vm.city);
            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
            }
            if (angular.isUndefined(vm.ti2)) {
              vm.ti2 = 0;
            }
          };

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.zip) && changes.zip.currentValue !== vm.zip) {
                vm.zip = changes.zip.currentValue;
              }
              if (angular.isDefined(changes.city) && changes.city.currentValue !== vm.city) {
                vm.city = changes.city.currentValue;
              }
            }
          };

          // typeahead zipcode search backend query
          function getNames(val) {
            $log.debug('loading city names');

            return Zipcode.$searchahead({
              query: val,
              fields: ['zipstr']
            }).$asPromise().then(function (response) {
              $log.debug('response: ', response);
              let rezip = response.map(function (zipcode) {
                zipcode.text = zipcode.zip + ' ' + zipcode.city;
                zipcode.label = zipcode.zip + ' ' + zipcode.city;
                // $log.debug('response zip: ', zipcode);
                return zipcode;
              });
              $log.debug(rezip);
              return rezip;
            });
          }

          // typeahead patient search action
          function getzipcity($item, $model, $label) {
            /* jshint unused:false */
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            //  $log.debug('orig zip: ', vm.zip);
            //  $log.debug('$model zip: ', $model.zip);
            //  $log.debug('orig city: ', vm.city);
            vm.zip = $model.zip;
            vm.city = $model.city;
            vm.save();
          }

          function foreignzip() {
            // $log.debug('foreignzip vm.zip:', vm.zip);
            // $log.debug('foreignzip asyncSelected:', vm.asyncSelected);
            if (!vm.zip) {
              if (angular.isString(vm.asyncSelected)) {
                vm.zip = vm.asyncSelected;
                // $log.debug('foreignzip string vm.zip:', vm.zip);
              }
              if (angular.isObject(vm.asyncSelected) && vm.asyncSelected.hasOwnProperty('zip')) {
                vm.zip = vm.asyncSelected.zip;
                // $log.debug('foreignzip object vm.zip:', vm.zip);
              }
              vm.save();
            }
          }

          function save() {
            if (!angular.equals(vm.zip, vm.lastzip) || !angular.equals(vm.city, vm.city)) {
              vm.lastzip = angular.copy(vm.zip);
              vm.lastcity = angular.copy(vm.city);
              $log.debug('debug: calling zipcode parentsave');
              vm.parentsave({zip: vm.zip, city: vm.city});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
